<template>
  <div class="cw-quote">
    <div class="cw-quote-heading">
      <span class="cw-quote-symbol"><v-icon aria-hidden="true">mdi-check-decagram-outline</v-icon></span>
      <div><h3>{{ quote.membership }}</h3><p class="cw-small">{{ quote.term.label }} · {{ customer.name }}</p></div>
    </div>
    <dl v-if="!compact" class="cw-quote-facts">
      <div><dt>Zeitraum</dt><dd>{{ date(quote.startDate) }} – {{ date(quote.endDate) }}</dd></div>
      <div><dt>Vertragsart</dt><dd>{{ quote.category.title }}<span v-if="quote.category.note" class="cw-block cw-small">{{ quote.category.info }}: {{ quote.category.note }}</span></dd></div>
      <div><dt>Zahlungsart</dt><dd v-if="quote.payment">{{ quote.payment.title }}<span v-if="quote.payment.date" class="cw-block cw-small">{{ date(quote.payment.date) }}</span></dd><dd v-else>Am Schluss auswählen</dd></div>
      <div v-if="issuer"><dt>Vertragspartner</dt><dd>{{ issuer.name }}<span class="cw-block cw-small">{{ issuer.street }} · {{ issuer.city }}</span></dd></div>
    </dl>
    <p v-if="!compact && quote.category.noteInfo" class="cw-note">{{ quote.category.noteInfo }}</p>
    <p v-if="!compact && quote.payment && quote.payment.info" class="cw-small cw-prose">{{ quote.payment.info }}</p>
    <div class="cw-quote-prices">
      <div class="cw-line"><span>Mitgliedschaft</span><span>{{ money(quote.baseCents) }}</span></div>
      <div v-for="extra in quote.extras" :key="extra.id" class="cw-line"><span>{{ extra.title }}<template v-if="extra.quantity > 1"> × {{ extra.quantity }}</template></span><span>{{ money(extra.totalCents) }}</span></div>
      <div class="cw-line"><span>Aktivierungs-Tarif</span><span>{{ money(quote.originalFeeCents) }}</span></div>
      <div v-for="(discount, index) in quote.discounts" :key="index" class="cw-line cw-success"><span>{{ discount.title }}<span v-if="discount.reason" class="cw-block cw-small">{{ discount.reason }}</span></span><span>− {{ money(discount.amountCents) }}</span></div>
      <div class="cw-quote-total"><span>Vertragstotal</span><strong>{{ money(quote.totalCents) }}</strong></div>
    </div>
    <template v-if="!compact"><p v-for="warning in quote.warnings" :key="warning" class="cw-small">{{ warning }}</p></template>
  </div>
</template>

<script>
import { money, date } from "./workspaceFormat"

export default {
  name: "ContractQuote",
  props: { quote: { type: Object, required: true }, customer: { type: Object, required: true }, issuer: { type: Object, default: null }, compact: Boolean },
  methods: { money, date },
}
</script>
